var _circle, _rect, _rect2, _circle2, _circle3, _path, _path2, _path3, _path4, _ellipse, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 135,
    fill: "#CADDFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.4828,
    height: 2.22799,
    rx: 1.11399,
    transform: "matrix(-0.989469 -0.144748 -0.144748 0.989469 159.354 128.886)",
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.4828,
    height: 2.22799,
    rx: 1.11399,
    transform: "matrix(-0.989736 0.142905 0.142905 0.989736 135.283 126.935)",
    fill: "#1778E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.50026,
    transform: "matrix(-1 0 0 1 150.603 138.186)",
    fill: "#1778E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.50026,
    transform: "matrix(-1 0 0 1 130.601 138.186)",
    fill: "#1778E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.316 139.436L144.488 144.481C145.095 145.447 144.772 146.729 143.721 147.173C141.79 147.988 139.345 148.649 138.102 147.77",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.343 157.453C134.97 155.379 139.998 151.74 147.091 153.769",
    stroke: "#1778E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.04 112.959C167.973 131.41 166.04 161.985 156.551 171.474C146.859 181.166 130.192 178.854 120.703 176.219C111.214 173.583 106.47 169.365 102.253 160.404C98.0358 151.442 95.3984 158.917 88.5465 151.442C82.748 145.116 82.2209 140.899 85.9107 132.464C89.2513 124.828 101.198 124.029 104.889 138.263",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.533 112.658C161.261 117.051 146.535 125.295 131.775 121.921C117.014 118.547 107.405 132.113 104.769 138.79C103.364 133.694 100.309 127.72 92.7648 127.72C88.0202 127.72 83.9787 135.451 83.803 137.736C73.7869 135.627 60.0805 127.72 76.9499 108.215C98.4081 83.4037 129.964 95.5799 141.264 82.9107C158.66 63.4056 191.872 71.3131 187.654 96.617C183.437 121.921 215.594 143.535 199.252 167.257C186.178 186.235 188.181 197.657 190.817 200.995",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.5,
    cy: 41.5,
    rx: 38.5,
    ry: 37.5,
    fill: "#185888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.68 48.72C220.68 47.5467 220.773 46.5733 220.96 45.8C221.147 45 221.48 44.28 221.96 43.64C222.467 42.9733 223.173 42.2933 224.08 41.6C225.067 40.8267 225.88 40.1333 226.52 39.52C227.16 38.9067 227.64 38.2533 227.96 37.56C228.28 36.84 228.44 35.9733 228.44 34.96C228.44 33.3333 227.933 32.12 226.92 31.32C225.907 30.4933 224.547 30.08 222.84 30.08C221.667 30.08 220.6 30.2267 219.64 30.52C218.707 30.7867 217.773 31.1467 216.84 31.6L216 29.68C217.12 29.1467 218.213 28.7467 219.28 28.48C220.373 28.1867 221.6 28.04 222.96 28.04C225.333 28.04 227.2 28.64 228.56 29.84C229.947 31.0133 230.64 32.7067 230.64 34.92C230.64 36.2 230.427 37.2933 230 38.2C229.6 39.08 229.027 39.88 228.28 40.6C227.533 41.32 226.653 42.0667 225.64 42.84C224.84 43.4533 224.213 44.04 223.76 44.6C223.333 45.16 223.027 45.7733 222.84 46.44C222.68 47.1067 222.6 47.9333 222.6 48.92V49.48H220.68V48.72ZM220 55.44C220 54.1333 220.587 53.48 221.76 53.48C222.933 53.48 223.52 54.1333 223.52 55.44C223.52 56.7733 222.933 57.44 221.76 57.44C220.587 57.44 220 56.7733 220 55.44Z",
    fill: "#F3FAFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.ac71e30e.svg";
export { ForwardRef as ReactComponent };